import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { useStickyAirPlusColumns } from './stickyColumns';

export const AIR_TABLE_HEADER_GRADIENT = 'linear-gradient(120deg, #0891b2, #8b5cf6)';

// Mounted only by AirPlusLayout, including its portal dialogs. Repeated wrapper
// specificity overrides the older page-level &&& header rules without changing
// shared tables or other modules. Calendar and date-picker grids are excluded.
const headers = [
  'body .ant-table-wrapper.ant-table-wrapper.ant-table-wrapper.ant-table-wrapper.ant-table-wrapper.ant-table-wrapper table > thead',
  'body table:not(.ant-picker-content):not(.ant-calendar-table):not(.fc-scrollgrid):not(.fc-col-header) > thead',
];
const select = (suffix = '') => headers.map((header) => `${header}${suffix}`).join(',\n');
const stickyCell = '[data-air-plus-sticky-column]'.repeat(7);

const AirTableHeaderStyles = createGlobalStyle`
  ${select()} {
    background: ${AIR_TABLE_HEADER_GRADIENT} !important;
    color: #fff;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  ${select(' > tr')},
  ${select(' > tr > th')},
  ${select(' > tr > th:hover')} {
    background: transparent !important;
  }

  ${select(' > tr > th')} {
    color: #fff !important;
  }

  /* Fixed cells must stay opaque when other columns scroll beneath them. */
  ${select(' > tr > th.ant-table-cell-fix-left')} {
    background: #0891b2 !important;
  }
  ${select(' > tr > th.ant-table-cell-fix-right')},
  ${select(' > tr > th.ant-table-cell-scrollbar')} {
    background: #8b5cf6 !important;
  }

  ${select(' .ant-table-column-sorter')},
  ${select(' .ant-table-filter-trigger')} {
    color: rgba(255, 255, 255, 0.75) !important;
  }
  ${select(' .ant-table-column-sorter .active')},
  ${select(' .ant-table-filter-trigger.active')} {
    color: #fff !important;
  }

  /* Only cells marked by the AirPlus-only controller are affected. The extra
     specificity also keeps fixed cells opaque under the shared header theme. */
  body ${stickyCell} {
    position: sticky !important;
    left: var(--air-plus-sticky-left) !important;
    right: auto !important;
    z-index: 3;
    background: var(--air-plus-sticky-background, #fff) !important;
  }
  body th${stickyCell} {
    z-index: 6;
    background: #0891b2 !important;
  }
  body table > thead:has(> tr > [data-air-plus-sticky-column]) { z-index: 7; }
  body [data-air-plus-sticky-edge] { box-shadow: 5px 0 7px -6px rgba(15, 41, 66, 0.45); }
  @media print {
    body ${stickyCell} {
      position: static !important;
      left: auto !important;
      box-shadow: none;
    }
  }
`;

function AirTableHeaderTheme() {
  useStickyAirPlusColumns();
  return <AirTableHeaderStyles />;
}

export default AirTableHeaderTheme;
